import React from 'react'
import { Row, Col } from 'reactstrap'

const InputWrapper = ({ children, md, customClass }) => {
  return (
    <Col md={md}>
      <div className='small-margin'>
        <Row className={`wrapper_filters ${customClass}`}>{children}</Row>
      </div>
    </Col>
  )
}

export default InputWrapper
